export const TestIds = {
  noReviewsPlaceholder: 'no-reviews-placeholder-test-id',
  ratingValue: 'rating-value-test-id',
  ratingIcons: 'rating-icons-test-id',
  splitIcon: 'split-icon-test-id',
  reviewsCounter: 'reviews-counter-test-id',
} as const;

export const NoReviewsMode = {
  NOTHING: 'nothing',
  EMPTY_ICONS: 'emptyIcons',
  PLACEHOLDER_TEXT: 'placeholderText',
};
